import script from "./add-relation.vue?vue&type=script&lang=tsx&setup=true"
export * from "./add-relation.vue?vue&type=script&lang=tsx&setup=true"

import "./add-relation.vue?vue&type=style&index=0&id=29530868&lang=scss"

const __exports__ = script;

export default __exports__